import { Component } from "@angular/core";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { WorkOrderService } from "@services/workOrder.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "spotOrders",
	styleUrls: ["spotOrders.css"],
	templateUrl: "spotOrders.html"
})
export class EdiSpotOrdersReportAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [];
	spotOrdersReportTable: any;
	title = "Spot Orders Report";

	constructor(private toastService: ToastService, private workOrderService: WorkOrderService) {
		this.getSpotOrdersReport();
	}

	getSpotOrdersReport() {
		this.workOrderService.spotOrdersReport()
			.subscribe(
				(res: any) => {
					this.spotOrdersReportTable = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}
}